import Button from "../../../../components/common/ui/Button";
import { history } from "../../../../_helpers/history";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import SelectInput from "../../../../components/common/ui/Inputs/SelectInput";
import RadioInput from "../../../../components/common/ui/Inputs/RadioInput";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import TextAreaInput from "../../../../components/common/ui/Inputs/TextAreaInput";
import { committeeActions } from "../../../../_store/committee.slice";
import { masterActions } from "../../../../_store/master.slice";
import committeeSchema from "../../../../validation/Admin/CommitteeSchema";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import { useLocation } from "react-router-dom";
import MultiSelectDropdown from "../../../../components/common/ui/Inputs/MultiSelectDropdown";

function CreateOrEditCommittee() {
  const dispatch = useDispatch();
  const location = useLocation();

  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [committeeChairList, setCommitteeChairList] = useState([]);
  const { committeeForm, getCommitteeByIDResponse } = useSelector(
    (x) => x?.committee
  );
  const { ActiveStatus, TrueOrFalse } = useSelector((x) => x?.dropDown);
  const { getAllActiveUsersResponse } = useSelector((x) => x?.master);

  const committeeID = location?.state ? location?.state?.committeeID : 0;
  // const committeeAdmin = location?.state ? location?.state?.committeeAdmin : {};
  const [committeeAdmin, setCommitteeAdmin] = useState({});

  useEffect(() => {
    if (committeeID === 0) {
      dispatch(committeeActions.resetCommitteeForm());
      return;
    }

    dispatch(committeeActions.getCommitteeByID(committeeID))
      .then((result) => {
        const response = { ...result?.payload?.data };
        dispatch(committeeActions.updateCommitteeForm(response));
        if (
          (response?.committeeAdmin?.fullName !== undefined ||
            response?.committeeAdmin?.fullName !== "undefined") &&
          (response?.committeeAdmin?._id !== undefined ||
            response?.committeeAdmin?._id !== "undefined") &&
          (response?.committeeAdmin?.role !== undefined ||
            response?.committeeAdmin?.role !== "undefined")
          // response?.committeeAdmin?._id !== undefined &&
          // response?.committeeAdmin?.role !== undefined
        ) {
          setCommitteeAdmin({
            label: response?.committeeAdmin?.fullName,
            value: response?.committeeAdmin?._id,
            role: response?.committeeAdmin?.role,
          });
        }
      })
      .catch((err) => {
        showToastNotification("Failed to get Committee Details", "error");
      });
  }, [committeeID, dispatch]);

  useEffect(() => {
    getUserList();
  }, [committeeAdmin]);

  const getUserList = () => {
    dispatch(masterActions?.getAllActiveUsers())
      .then((result) => {
        const committeeChairList = [...result?.payload?.data?.formattedUsers];

        // const updatedArr = [
        //   ...committeeForm.committeeAdmin
        //     .filter((admin) => admin?.role !== 3)
        //     .map((admin) => ({
        //       label: `${admin.fullName} (${admin.email})`,
        //       value: admin._id,
        //     })),
        //   ...committeeChairList,
        // ];

        setCommitteeChairList(committeeChairList);
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  };

  const handleChange = (e, select) => {
    const formData = { ...committeeForm };

    if (select) {
      formData[select] = { ...formData[select], _id: e?.value }; // clone & update
      dispatch(committeeActions.updateCommitteeForm(formData));
      return;
    }

    const { name, value, type } = e?.target;
    if (value.startsWith(" ")) return;

    let newValue = value;

    if (name === "committeeName") {
      // Allow only letters, numbers, spaces, hyphens, &, (), ., @
      newValue = value.replace(/[^a-zA-Z0-9\s\-&().@_']/g, "");
    }

    formData[name] =
      type === "radio" ? (newValue === "true" ? true : false) : newValue;
    dispatch(committeeActions.updateCommitteeForm(formData));
  };

  const handleSelectChange = (selectedOptions, fieldName) => {
    const selectedIds = selectedOptions?.map((item) => item.value) || [];

    // Update committeeForm inside Redux
    dispatch(
      committeeActions.updateCommitteeForm({
        ...committeeForm,
        [fieldName]: selectedIds, // updates committeeAdmin as an array of ids
      })
    );

    // setRegisterForm((prevForm) => ({
    //   ...prevForm,
    //   [fieldName]: selectedIds,
    // }));
  };

  const handleFormSubmit = (e) => {
    setIsPending(true);
    e?.preventDefault();
    setErrorMessage({});
    console.log(committeeForm);

    const form = { ...committeeForm };
    // form["committeeAdmin"] = committeeForm?.committeeAdmin?._id || "";

    const { error } = committeeSchema(form);
    if (error?.details) {
      setIsPending(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }
    //API call after validation
    const resquest = committeeID
      ? dispatch(committeeActions?.updateCommittee(form))
      : dispatch(committeeActions?.CreateCommittee(form));
    resquest
      .then((result) => {
        debugger;
        setIsPending(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          dispatch(committeeActions.resetCommitteeForm());
          history?.navigate("/Admin/Committee", {
            state: { committeeID: 0 },
          });
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setIsPending(false);
      });
  };

  const handleFormReset = () => {
    setErrorMessage({});
    if (committeeID) {
      dispatch(committeeActions.getCommitteeByID(committeeID))
        .then((result) => {
          dispatch(committeeActions.updateCommitteeForm(result?.payload?.data));
        })
        .catch((err) => {
          showToastNotification("Failed to get Committee Details", "error");
        });
    } else {
      dispatch(committeeActions.resetCommitteeForm());
    }
  };

  // console.log("committeeForm", committeeForm);
  // console.log("committeeChairList", committeeChairList);
  // console.log(committeeForm?.committeeAdmin);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">Committee</h1>
        <Button
          label="Back"
          status="reset"
          onClick={() => {
            history?.navigate("/Admin/Committee", {
              state: { committeeID: 0 },
            });
            dispatch(committeeActions.resetCommitteeForm());
          }}
        />
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          {committeeID ? "Edit " : "Create "}Committee
        </h1>
        <form
          onSubmit={(e) => {
            handleFormSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
          className="p-3 row"
        >
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                label="Committee Name"
                placeholder="Committee name"
                name="committeeName"
                id="committeeName"
                handleChange={(e) => handleChange(e)}
                required
                errorMessage={errorMessage}
                value={committeeForm?.committeeName}
                maxLength={60}
              />
            </div>
            <div className="col-md-4">
              {/* <SelectInput
                options={committeeChairList}
                name="committeeAdmin"
                id="committeeAdmin"
                label="Committee Chair"
                required
                handleChange={(e) => handleChange(e, "committeeAdmin")}
                errorMessage={errorMessage}
                value={committeeForm?.committeeAdmin?._id}
              /> */}
              <MultiSelectDropdown
                name="committeeAdmin"
                options={committeeChairList}
                displayValue="label"
                handleChange={(e) => handleSelectChange(e, "committeeAdmin")}
                placeholder="Choose Committee"
                label="Choose Chair"
                required
                errorMessage={errorMessage}
                // selectedValue={
                //   Array.isArray(committeeChairList) &&
                //   Array.isArray(committeeForm?.committeeAdmin)
                //     ? committeeChairList.filter((option) =>
                //         committeeForm.committeeAdmin.includes(option.value)
                //       )
                //     : []
                // }
                // selectedValue={
                //   Array.isArray(committeeChairList) &&
                //   Array.isArray(committeeForm?.committeeAdmin)
                //     ? committeeChairList.filter((option) => {
                //         const selectedIds = committeeForm.committeeAdmin.map(
                //           (item) => (typeof item === "object" ? item._id : item)
                //         );
                //         return selectedIds.includes(option.value);
                //       })
                //     : []
                // }
                selectedValue={
                  Array.isArray(committeeChairList) &&
                  Array.isArray(committeeForm?.committeeAdmin)
                    ? committeeChairList.filter((option) => {
                        const selectedIds = committeeForm.committeeAdmin.map(
                          (item) => (typeof item === "object" ? item._id : item)
                        );
                        return selectedIds.includes(option.value);
                      })
                    : []
                }
                // selectedValue={[{label:"hello",value:"68a5a15d978fc1c6aceece5d"},"68a5a15d978fc1c6aceece60"]}
              />
            </div>
            <div className="col-md-4">
              <RadioInput
                name="status"
                id="status"
                label="Status"
                options={ActiveStatus}
                handleChange={(e) => handleChange(e)}
                selectedValue={committeeForm?.status}
              />
            </div>
            <div className="col-md-4">
              <RadioInput
                name="secretCommittee"
                id="secretCommittee"
                label="Secret Committee"
                options={TrueOrFalse}
                handleChange={(e) => handleChange(e)}
                selectedValue={committeeForm?.secretCommittee}
              />
            </div>
            <div className="col-md-8">
              <TextAreaInput
                type="text"
                label="Committee Description"
                placeholder="Committee Description"
                name="committeeDescription"
                id="committeeDescription"
                handleChange={(e) => handleChange(e)}
                // required
                errorMessage={errorMessage}
                value={committeeForm?.committeeDescription}
                maxLength={500}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <Button
              label={`${committeeID === 0 ? "Submit" : "Update"}`}
              type="submit"
              status="secondary"
              disabled={isPending}
            />
            <Button label="Reset" type="reset" status="reset" />
          </div>
        </form>
      </div>
    </>
  );
}

export default CreateOrEditCommittee;
